import React from 'react';

export default function SelectColumnSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0742 17H1.92434C0.863006 17 0 16.137 0 15.0757V1.92434C0 0.863006 0.863006 0 1.92434 0H15.0742C16.1356 0 16.9986 0.863006 16.9986 1.92434V15.0749C16.9993 16.137 16.1356 17 15.0742 17ZM1.92434 0.934145C1.37822 0.934145 0.934145 1.37822 0.934145 1.92434V15.0749C0.934145 15.6211 1.37894 16.0651 1.92434 16.0651H15.0742C15.6203 16.0651 16.0644 15.6203 16.0644 15.0749V1.92434C16.0644 1.37822 15.6196 0.934145 15.0742 0.934145H1.92434Z"
        fill="#35198E"
      />
      <path
        d="M15.6448 3.70659H1.35379C0.607194 3.70659 0 3.0994 0 2.35208C0 2.09411 0.209105 1.88501 0.467072 1.88501C0.72504 1.88501 0.934145 2.09411 0.934145 2.35208C0.934145 2.58346 1.12241 2.77245 1.35379 2.77245H15.6448C15.8762 2.77245 16.0651 2.58346 16.0651 2.35208C16.0651 2.09411 16.2742 1.88501 16.5322 1.88501C16.7902 1.88501 16.9993 2.09411 16.9993 2.35208C16.9993 3.0994 16.3914 3.70659 15.6448 3.70659Z"
        fill="#35198E"
      />
      <path
        d="M16.2043 13.7264H0.795197C0.53723 13.7264 0.328125 13.5173 0.328125 13.2593C0.328125 13.0013 0.53723 12.7922 0.795197 12.7922H16.2043C16.4622 12.7922 16.6713 13.0013 16.6713 13.2593C16.6713 13.5173 16.4622 13.7264 16.2043 13.7264Z"
        fill="#35198E"
      />
      <path
        d="M16.2043 10.3209H0.795197C0.53723 10.3209 0.328125 10.1118 0.328125 9.85379C0.328125 9.59582 0.53723 9.38672 0.795197 9.38672H16.2043C16.4622 9.38672 16.6713 9.59582 16.6713 9.85379C16.6713 10.1118 16.4622 10.3209 16.2043 10.3209Z"
        fill="#35198E"
      />
      <path
        d="M16.2043 6.91486H0.795197C0.53723 6.91486 0.328125 6.70575 0.328125 6.44779C0.328125 6.18982 0.53723 5.98071 0.795197 5.98071H16.2043C16.4622 5.98071 16.6713 6.18982 16.6713 6.44779C16.6713 6.70575 16.4622 6.91486 16.2043 6.91486Z"
        fill="#35198E"
      />
      <path
        d="M5.81912 16.8719C5.56116 16.8719 5.35205 16.6628 5.35205 16.4048V3.33255C5.35205 3.07458 5.56116 2.86548 5.81912 2.86548C6.07709 2.86548 6.2862 3.07458 6.2862 3.33255V16.4048C6.2862 16.6628 6.07709 16.8719 5.81912 16.8719Z"
        fill="#35198E"
      />
      <path
        d="M11.5032 16.8719C11.2452 16.8719 11.0361 16.6628 11.0361 16.4048V3.33255C11.0361 3.07458 11.2452 2.86548 11.5032 2.86548C11.7612 2.86548 11.9703 3.07458 11.9703 3.33255V16.4048C11.9703 16.6628 11.7612 16.8719 11.5032 16.8719Z"
        fill="#35198E"
      />
      <rect
        x="0.894531"
        y="3.57886"
        width="4.47368"
        height="2.68421"
        fill="#35198E"
      />
      <rect
        x="11.6318"
        y="3.57886"
        width="4.47368"
        height="2.68421"
        fill="#35198E"
      />
    </svg>
  );
}
